(function () {
  'use strict';

  function initMegaMenuTabs(megaMenu) {
    const buttons = Array.from(megaMenu.querySelectorAll('[data-megamenu-dropdown-control]'));
    if (!buttons.length) return;

    function activate(activeBtn) {
      buttons.forEach(function (btn) {
        const panel = megaMenu.querySelector('[data-megamenu-dropdown="' + btn.dataset.megamenuDropdownControl + '"]');
        const isActive = btn === activeBtn;
        btn.classList.toggle('active', isActive);
        if (panel) {
          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
        }
      });
    }

    activate(buttons[0]);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn); });
    });
  }

  function initMobileMegaMenuTabs(container) {
    const buttons = Array.from(container.querySelectorAll('[data-mb-megamenu-dropdown-control]'));
    if (!buttons.length) return;

    function activate(activeBtn) {
      buttons.forEach(function (btn) {
        const panel = container.querySelector('[data-mb-megamenu-dropdown="' + btn.dataset.mbMegamenuDropdownControl + '"]');
        const isActive = btn === activeBtn;
        btn.classList.toggle('active', isActive);
        if (panel) {
          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
        }
      });
    }

    activate(buttons[0]);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn); });
    });
  }

  function initHeaderRadius() {
    var header = document.querySelector('store-header');
    if (!header) return;

    var overlay = document.createElement('div');
    overlay.className = 'bl-mm__overlay';
    // document.body.appendChild(overlay);

    function updateState() {
      var isOpen = !!document.querySelector('.bl-mega-menu:not([hidden]):not(.is-closing)');
      header.classList.toggle('bl-mm-open', isOpen);
      overlay.classList.toggle('active', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';

      var firstNavDropdown = document.querySelector('desktop-navigation .nav-dropdown:not(.mega-menu)');
      var isNavDropdownOpen = !!firstNavDropdown &&
        !firstNavDropdown.hasAttribute('hidden') &&
        !firstNavDropdown.classList.contains('is-closing');
      header.classList.toggle('bl-nav-dropdown-open', isNavDropdownOpen);
    }

    document.addEventListener('desktop-nav:dropdown:open', updateState);
    document.addEventListener('desktop-nav:dropdown:close', updateState);
  }

  function initQuickFilter() {
    var buttons = Array.from(document.querySelectorAll('.bl_quick_filter__button[data-collection-filter-tag]'));
    if (!buttons.length) return;

    var productFacet = document.querySelector('product-facet');

    function getCollectionInfo() {
      var parts = window.location.pathname.split('/').filter(Boolean);
      return {
        base: '/' + parts.slice(0, 2).join('/'),
        activeTag: parts[2] || null
      };
    }

    function syncActiveState() {
      var activeTag = getCollectionInfo().activeTag;
      buttons.forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.collectionFilterTag === activeTag);
      });
    }

    syncActiveState();

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.dataset.collectionFilterTag;
        var info = getCollectionInfo();
        var isActive = info.activeTag === tag;
        var newUrl = isActive ? info.base : info.base + '/' + tag;

        buttons.forEach(function (b) { b.classList.remove('active'); });
        if (!isActive) btn.classList.add('active');

        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start'));

        if (productFacet) {
          productFacet.dispatchEvent(new CustomEvent('facet:criteria-changed', {
            bubbles: true,
            detail: { url: newUrl }
          }));
        } else {
          window.location.href = newUrl;
        }
      });
    });
  }

  function initQuickNavInQuickBuy() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.bl-product-form__quick-nav_scroller a[href]');
      if (!link) return;

      var drawer = link.closest('quick-buy-drawer');
      var popover = link.closest('quick-buy-popover');
      var container = drawer || popover;
      if (!container) return;

      // Quick-nav items can point at a collection as well as a product. A
      // collection page has no #quick-buy-content to re-render the drawer
      // from, so let the browser navigate to it (theme loading bar as
      // feedback). Only product links swap the drawer content in place.
      if (link.pathname.indexOf('/products/') === -1) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start'));
        return;
      }

      event.preventDefault();

      var productUrl = link.getAttribute('href');
      var tagName = drawer ? 'quick-buy-drawer' : 'quick-buy-popover';

      container.classList.add('bl-quick-nav--loading');

      var loaderEl = document.createElement('div');
      loaderEl.className = 'bl-quick-nav__loader';
      loaderEl.innerHTML =
        '<div class="spinner">' +
          '<svg focusable="false" width="32" height="32" class="icon icon--spinner" viewBox="25 25 50 50">' +
            '<circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>' +
          '</svg>' +
        '</div>';
      container.appendChild(loaderEl);

      fetch(productUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var fragment = document.createRange().createContextualFragment(html);
          var template = fragment.querySelector('#quick-buy-content');
          if (!template) return;

          var newEl = template.content.querySelector(tagName);
          if (!newEl) return;

          container.replaceChildren.apply(container, Array.from(newEl.children));

          if (window.Shopify && window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }

          var selected = container.querySelector('.bl-product-form__quick-nav_scroller .selected');
          if (selected) {
            selected.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        })
        .catch(function (err) {
          console.error('[Quick Nav] Failed to load product in quick-buy:', err);
          if (loaderEl.parentNode) loaderEl.remove();
        })
        .finally(function () {
          container.classList.remove('bl-quick-nav--loading');
        });
    });
  }

  /**
   * Product media (mobile): pin to top:14, then stop 14px above the variant-picker.
   *
   * This is done with NATIVE CSS sticky only — no per-frame JS positioning, so
   * it is butter-smooth and jump-free at ANY scroll speed (the browser handles
   * the pin AND the stop on the compositor):
   *
   *   - product-media is `position: sticky; top: 14px` (see bl-custom.css).
   *   - A `margin-bottom` is added to it so the browser releases it exactly GAP
   *     px above the variant-picker (a sticky element stops when its margin box
   *     reaches the bottom of its containing block, here `.product`).
   *   - The SAME amount is removed from the next sibling (`.product__info`) as a
   *     negative `margin-top`, so the two cancel and the layout doesn't shift.
   *
   * Earlier versions switched position with JS at the stop point; native sticky
   * always lagged the JS by a frame, which caused the catch-up "blink". Letting
   * the browser own the stop removes that entirely. JS here only: (a) computes
   * those two margins on load / resize / re-render, and (b) toggles the scale
   * class as the media pins.
   */
  function initProductMediaStickyMobile() {
    var section = document.querySelector('.shopify-section--main-product');
    if (!section) return;

    var STICKY_TOP = 14; // px below the viewport top the media pins to
    var GAP = 14;        // px the media keeps above the variant-picker
    var mq = window.matchMedia('(max-width: 999px)');

    var product = null;
    var media = null;
    var info = null;
    var variantPicker = null;
    var isScaled = false;
    var pinStartY = 0;   // scrollY at which the media starts pinning (scale cue)

    function docTop(el) {
      var y = 0;
      while (el) { y += el.offsetTop; el = el.offsetParent; }
      return y;
    }

    function findEls() {
      product = section.querySelector('.product');
      media = section.querySelector('product-media');
      info = section.querySelector('.product__info');
      variantPicker = section.querySelector('variant-picker');
      return !!(product && media && info && variantPicker);
    }

    function clearMargins() {
      if (media) media.style.marginBottom = '';
      if (info) info.style.marginTop = '';
    }

    // Size the sticky stop: margin-bottom makes the browser release the media
    // when its margin box reaches `.product`'s content bottom; choosing it so
    // that release point sits exactly GAP px above the variant-picker. The next
    // sibling's negative margin-top cancels it so nothing shifts in the layout.
    function layout() {
      // Measure in a clean state.
      media.style.marginBottom = '';
      info.style.marginTop = '';

      var cs = window.getComputedStyle(product);
      var padBottom = parseFloat(cs.paddingBottom) || 0;
      var cbBottom = docTop(product) + product.clientHeight - padBottom; // .product content-box bottom
      var pickerTop = docTop(variantPicker);
      var margin = cbBottom - (pickerTop - GAP);
      if (margin < 0) margin = 0;

      media.style.marginBottom = margin + 'px';
      info.style.marginTop = (-margin) + 'px';
      pinStartY = docTop(media) - STICKY_TOP;
    }

    function updateScale() {
      if (!media) return;
      var shouldScale = mq.matches && window.scrollY >= pinStartY;
      if (shouldScale !== isScaled) {
        isScaled = shouldScale;
        media.classList.toggle('bl-media--scaled', shouldScale);
      }
    }

    // Runs on load, resize, breakpoint change and whenever the section's box
    // changes (lazy images, variant re-render — which can replace these nodes).
    function recompute() {
      if (!findEls()) return;
      if (!mq.matches) { clearMargins(); updateScale(); return; } // desktop: CSS only
      layout();
      updateScale();
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { updateScale(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', recompute);
    if (mq.addEventListener) mq.addEventListener('change', recompute);
    if (window.ResizeObserver) new ResizeObserver(recompute).observe(section);

    recompute();
  }

  // Temperature-retention bars: fill each bar to (value / max) when it scrolls
  // into view. Lives here (not in an inline <script>) because the quick-buy
  // drawer/popover clone their content out of a <template> — inline scripts
  // never execute there, and DOMContentLoaded has long since fired. A
  // MutationObserver picks up every dynamically injected copy.
  function initTempRetentionBars() {
    var SELECTOR = '.bl_hot_retention__bar, .bl_cold_retention__bar';

    function fill(bar) {
      if (bar.dataset.blRetentionDone) return; // animate once per element
      bar.dataset.blRetentionDone = '1';

      var max = parseFloat(bar.getAttribute('data-max')) || 24;
      var value = parseFloat(bar.getAttribute('data-value')) || 0;
      var pct = Math.min(100, (value / max) * 100);

      function apply() { bar.style.setProperty('--bar-width', pct + '%'); }

      if (!('IntersectionObserver' in window)) { apply(); return; }
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { apply(); obs.unobserve(bar); }
        });
      }, { threshold: 0.5 });
      io.observe(bar);
    }

    function scan(root) {
      if (!root || !root.querySelectorAll) return;
      if (root.matches && root.matches(SELECTOR)) fill(root);
      root.querySelectorAll(SELECTOR).forEach(fill);
    }

    scan(document);

    // Catch bars injected after load: quick-buy drawer/popover, the quick-nav
    // swap (initQuickNavInQuickBuy), variant re-renders, etc.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // Quick-nav scroll progress bar: the row's native scrollbar is hidden, so a
  // #D9D9D9 fill along the bottom of the pill is the cue that it is slidable.
  // The fill mirrors how much of the row has been seen — the visible fraction
  // at rest, 100% when scrolled to the end — and the whole indicator stays
  // hidden when the row doesn't overflow. Lives here (not inline) for the same
  // reason as the retention bars: quick-buy drawer/popover content is cloned
  // out of a <template>, so inline scripts never execute there. The
  // MutationObserver wires up every injected copy, and a ResizeObserver on the
  // scroller + its items keeps the fill correct when the drawer becomes
  // visible or lazy images change widths.
  // Quick-nav row (product page + quick-buy drawer/popover):
  //   1. Scrollbar indicator — a real thumb whose size is the visible fraction
  //      of the row and whose position follows the scroll.
  //   2. Drag the thumb, or click the track, to scroll the row.
  //   3. Drag the row itself with a mouse/pen (touch keeps native scrolling).
  //      A drag that moved never opens the item under the cursor.
  function initQuickNavScrollbars() {
    var SELECTOR = '.bl-product-form__quick-nav_scrollbar';
    var MIN_THUMB = 24;     // px — keeps the thumb grabbable on long rows
    var DRAG_THRESHOLD = 4; // px — below this a press is a click, not a drag

    function setup(bar) {
      if (bar.dataset.blScrollbarReady) return;
      bar.dataset.blScrollbarReady = '1';

      var wrapper = bar.closest('.bl-product-form__quick-nav_wrapper');
      var scroller = wrapper && wrapper.querySelector('.bl-product-form__quick-nav_scroller');
      var thumb = bar.querySelector('.bl-product-form__quick-nav_scrollbar-thumb');
      if (!scroller || !thumb) return;

      function maxScroll() {
        return scroller.scrollWidth - scroller.clientWidth;
      }

      /* ---------- 1. Indicator ---------- */
      function update() {
        var max = maxScroll();
        if (max <= 1) { bar.hidden = true; return; }
        bar.hidden = false;

        var barW = bar.clientWidth;
        var thumbW = Math.max(MIN_THUMB, barW * (scroller.clientWidth / scroller.scrollWidth));
        var x = (Math.abs(scroller.scrollLeft) / max) * (barW - thumbW);
        thumb.style.width = thumbW + 'px';
        thumb.style.transform = 'translateX(' + x + 'px)';
      }

      scroller.addEventListener('scroll', update, { passive: true });

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(update);
        ro.observe(scroller);
        Array.prototype.forEach.call(scroller.children, function (child) { ro.observe(child); });
      } else {
        window.addEventListener('resize', update);
      }

      update();

      /* ---------- 2. Thumb drag / track click ---------- */
      // px of row scroll per px of thumb travel.
      function ratio() {
        var travel = bar.clientWidth - thumb.getBoundingClientRect().width;
        return travel > 0 ? maxScroll() / travel : 0;
      }

      var barDragging = false, barStartX = 0, barStartScroll = 0;

      bar.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || maxScroll() <= 1) return;
        e.preventDefault();

        if (!thumb.contains(e.target)) {
          // Track click: jump so the thumb centres under the pointer, then
          // keep following the pointer if it moves.
          var rect = bar.getBoundingClientRect();
          var thumbW = thumb.getBoundingClientRect().width;
          scroller.scrollLeft = (e.clientX - rect.left - thumbW / 2) * ratio();
        }

        barDragging = true;
        barStartX = e.clientX;
        barStartScroll = scroller.scrollLeft;
        bar.classList.add('is-dragging');
        try { bar.setPointerCapture(e.pointerId); } catch (err) {}
      });

      bar.addEventListener('pointermove', function (e) {
        if (!barDragging) return;
        scroller.scrollLeft = barStartScroll + (e.clientX - barStartX) * ratio();
      });

      function endBarDrag() {
        if (!barDragging) return;
        barDragging = false;
        bar.classList.remove('is-dragging');
      }
      bar.addEventListener('pointerup', endBarDrag);
      bar.addEventListener('pointercancel', endBarDrag);

      /* ---------- 3. Drag the row with a mouse / pen ---------- */
      var dragging = false, moved = false, suppressClick = false;
      var startX = 0, startScroll = 0;

      scroller.addEventListener('pointerdown', function (e) {
        suppressClick = false; // every press starts clean so a stale flag can't eat a tap
        if (e.pointerType === 'touch' || e.button !== 0 || maxScroll() <= 1) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = scroller.scrollLeft;
        // Pointer capture is taken only once a genuine drag begins (pointermove);
        // capturing here would route the follow-up click away from the item link.
      });

      scroller.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (!moved) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          moved = true;
          scroller.classList.add('is-dragging');
          try { scroller.setPointerCapture(e.pointerId); } catch (err) {}
        }
        scroller.scrollLeft = startScroll - dx;
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        scroller.classList.remove('is-dragging');
        if (moved) suppressClick = true; // the release will emit a click on whatever is under the cursor
      }
      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);

      // Capture phase so a drag is swallowed before the quick-buy swap handler
      // on document (initQuickNavInQuickBuy) and before the link navigates.
      scroller.addEventListener('click', function (e) {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);

      // Stop the browser's native image / link drag ghost from hijacking the gesture.
      scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    function scan(root) {
      if (!root || !root.querySelectorAll) return;
      if (root.matches && root.matches(SELECTOR)) setup(root);
      root.querySelectorAll(SELECTOR).forEach(setup);
    }

    scan(document);

    // Catch indicators injected after load: quick-buy drawer/popover, the
    // quick-nav product swap (initQuickNavInQuickBuy), variant re-renders, etc.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // Product media gallery (mobile): dynamic-width progress bar under the
  // images. The media-nav (dots/thumbnails) is hidden on mobile (see
  // bl-custom.css), so this #D9D9D9 fill is the only cue that the gallery is
  // swipable. Same "seen fraction" concept as the quick-nav bar, but the
  // gallery is a Flickity carousel (transform-based — native scrollLeft stays
  // 0), so the fill is driven by Flickity's scroll progress instead of a
  // scroll listener. Re-wires itself on flickity:ready because variant
  // filtering reloads (destroys + recreates) the instance. Desktop never shows
  // the bar (hidden-lap-and-up class in the markup).
  function initProductMediaProgress() {
    var SELECTOR = '.bl-product-media__progress';

    function setup(bar) {
      if (bar.dataset.blProgressReady) return;
      bar.dataset.blProgressReady = '1';

      var wrapper = bar.closest('.product__media-list-wrapper');
      var carousel = wrapper && wrapper.querySelector('.product__media-list');
      var fill = bar.firstElementChild;
      if (!carousel || !fill) return;

      function wire() {
        // Single visible media: the carousel never initializes → bar stays hidden.
        if (!carousel.flickityInstance) return;
        Promise.resolve(carousel.flickityInstance).then(function (flkty) {
          if (!flkty || flkty._blProgressWired) return;
          flkty._blProgressWired = true;

          function update(progress) {
            var count = (flkty.slides && flkty.slides.length) || 0;
            if (count < 2) { bar.hidden = true; return; }
            bar.hidden = false;

            // Fill = fraction of the strip already seen: the visible fraction
            // at rest, 100% on the last slide. Falls back to slide-index math
            // if Flickity's size metrics are unavailable.
            var p = Math.min(Math.max(progress || 0, 0), 1);
            var total = flkty.slidesWidth;
            var viewport = flkty.size && flkty.size.innerWidth;
            var seen = total && viewport && total > viewport
              ? (p * (total - viewport) + viewport) / total
              : (1 + p * (count - 1)) / count;
            fill.style.width = Math.min(seen * 100, 100) + '%';
          }

          flkty.on('scroll', update);
          update(flkty.slides.length > 1 ? flkty.selectedIndex / (flkty.slides.length - 1) : 0);
        });
      }

      carousel.addEventListener('flickity:ready', wire);
      wire();
    }

    function scan(root) {
      if (!root || !root.querySelectorAll) return;
      if (root.matches && root.matches(SELECTOR)) setup(root);
      root.querySelectorAll(SELECTOR).forEach(setup);
    }

    scan(document);

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // "Customise" button (product form + quick-buy drawer/popover): carry the
  // currently-selected variant to the customiser via ?variant=<id>, so it can
  // pre-select that bottle colour. The customiser (bl_flexidesign.js) falls back to
  // the first option when the variant is missing or out of stock. Delegated on
  // document so it also covers buttons injected into the quick-buy drawer AFTER load;
  // buttons with no variant context (e.g. product cards) navigate normally.
  function initCustomiseDeepLink() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.bl_form__button_customisation');
      if (!btn) return;
      // Don't hijack open-in-new-tab/window: let modifier / non-left clicks use the
      // native href (they open the base customise page; deep-link is for plain click).
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var href = btn.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      // Read the selected variant from the surrounding product context: prefer the
      // Focal <variant-picker> (its .selectedVariant tracks colour/size changes),
      // else the form's hidden [name="id"] input.
      var scope = btn.closest('.product-form, product-info, .product, .shopify-section') || document;
      var picker = scope.querySelector('variant-picker');
      var variantId = (picker && picker.selectedVariant && picker.selectedVariant.id) || null;
      if (!variantId) {
        var idInput = scope.querySelector('[name="id"]');
        variantId = (idInput && idInput.value) || null;
      }
      if (!variantId) return; // no variant context → let the href navigate as-is
      var url;
      try { url = new URL(href, window.location.href); } catch (err) { return; }
      url.searchParams.set('variant', String(variantId));
      e.preventDefault();
      window.location.href = url.toString();
    });
  }

  function initBundleCartCount() {
    var expected = null; // last known bundle-aware count, as a string

    function countFromCart(cart) {
      if (!cart || !cart.items) return null;
      var n = 0;
      cart.items.forEach(function (it) {
        if (!(it.properties && it.properties['_flexidesign'])) n += it.quantity;
      });
      return String(n);
    }
    function paint() {
      if (expected == null) return;
      document.querySelectorAll('cart-count').forEach(function (el) {
        if (el.textContent !== expected) el.textContent = expected;
      });
    }
    function onCartEvent(e) {
      var v = countFromCart(e && e.detail && e.detail.cart);
      if (v != null) { expected = v; paint(); return; }
      // Event without line items → fetch the full cart, then correct.
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { expected = countFromCart(cart); paint(); })
        .catch(function () {});
    }

    // cart:updated / cart:refresh bubble to documentElement (theme + bl_cart-bundle).
    // Our listeners run AFTER the theme's <cart-count> handler, so they correct it.
    document.documentElement.addEventListener('cart:updated', onCartEvent);
    document.documentElement.addEventListener('cart:refresh', onCartEvent);

    // Seed from the server-rendered badge (already bundle-aware) and enforce it: a
    // late async item_count write by the theme is re-corrected by the observer.
    var seed = document.querySelector('cart-count');
    if (seed) expected = (seed.textContent || '').trim();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(paint);
      document.querySelectorAll('cart-count').forEach(function (el) {
        mo.observe(el, { childList: true, characterData: true, subtree: true });
      });
    }
  }

  /* ── Device trace → order attributes ─────────────────────────────────────
     Registers the visitor's browser / OS / device model as HIDDEN cart
     attributes (leading "_" keeps them off customer-facing surfaces). Cart
     attributes become the order's note_attributes at checkout, so every order
     can be traced back to the exact device/browser when debugging an issue.
     The raw user-agent is stored too — parsed fields are the quick glance,
     the UA is the full-fidelity source. Never throws: tracing must not break
     the page, and /cart/update.js MERGES attributes so nothing else on the
     cart is touched. */
  function getDeviceDetails() {
    var ua = navigator.userAgent;
    var pick = function (re) { return (ua.match(re) || [])[1] || ''; };

    // Order matters: Chromium Edge/Opera/Samsung UAs all contain "Chrome",
    // and modern Edge identifies as "Edg/" (not "Edge/").
    var browser = 'NA', bVer = '';
    if (ua.indexOf('Firefox') !== -1 && ua.indexOf('Seamonkey') === -1) { browser = 'Firefox'; bVer = pick(/Firefox\/([\d.]+)/); }
    else if (ua.indexOf('SamsungBrowser') !== -1) { browser = 'Samsung Internet'; bVer = pick(/SamsungBrowser\/([\d.]+)/); }
    else if (ua.indexOf('Edg') !== -1)            { browser = 'Microsoft Edge';   bVer = pick(/Edg(?:e|A|iOS)?\/([\d.]+)/); }
    else if (ua.indexOf('OPR') !== -1 || ua.indexOf('Opera') !== -1) { browser = 'Opera'; bVer = pick(/(?:OPR|Opera)\/([\d.]+)/); }
    else if (ua.indexOf('CriOS') !== -1)          { browser = 'Google Chrome (iOS)'; bVer = pick(/CriOS\/([\d.]+)/); }
    else if (ua.indexOf('Chrome') !== -1 && ua.indexOf('Chromium') === -1) { browser = 'Google Chrome'; bVer = pick(/Chrome\/([\d.]+)/); }
    else if (ua.indexOf('Safari') !== -1)         { browser = 'Safari'; bVer = pick(/Version\/([\d.]+)/); }
    else if (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') !== -1) { browser = 'Internet Explorer'; bVer = pick(/(?:MSIE |rv:)([\d.]+)/); }

    var os = 'NA';
    if (ua.indexOf('Android') !== -1)        os = ('Android ' + pick(/Android\s+([\d.]+)/)).trim();
    else if (/iPhone|iPad|iPod/.test(ua))    os = ('iOS ' + pick(/OS (\d+[_\d]*)/).replace(/_/g, '.')).trim();
    else if (ua.indexOf('Windows NT') !== -1) os = 'Windows';
    else if (ua.indexOf('Macintosh') !== -1)  os = 'macOS';
    else if (ua.indexOf('Linux') !== -1)      os = 'Linux';

    // Model: high-entropy client hints are the reliable source on modern
    // Chrome — Android UA-reduction replaces the real model in the UA string
    // with the literal "K", so the UA regex is only a legacy fallback.
    var finish = function (model) {
      if (!model || model === 'K') {
        if (ua.indexOf('iPhone') !== -1)      model = 'iPhone (exact model hidden by iOS)';
        else if (ua.indexOf('iPad') !== -1)   model = 'iPad (exact model hidden by iOS)';
        else if (os.indexOf('Android') === 0) model = pick(/Android\s+[\d.]+;\s+([^;)]+)/).trim() || 'NA';
        else model = 'NA';
        if (model === 'K') model = 'NA';
      }
      return {
        browser: (browser + (bVer ? ' ' + bVer : '')).trim(),
        os: os,
        model: model,
      };
    };

    if (navigator.userAgentData && typeof navigator.userAgentData.getHighEntropyValues === 'function') {
      return navigator.userAgentData.getHighEntropyValues(['model'])
        .then(function (hints) { return finish(hints.model); })
        .catch(function () { return finish(''); });
    }
    return Promise.resolve(finish(''));
  }

  function initDeviceTraceAttributes() {
    getDeviceDetails().then(function (info) {
      var attrs = {
        '_DeviceBrowser': info.browser,
        '_DeviceOS':      info.os,
        '_DeviceModel':   info.model,
        '_DeviceUA':      navigator.userAgent,
      };
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      // Register only when missing/changed: one lightweight GET per page load;
      // the POST then happens once per cart, not on every page view.
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cur = (cart && cart.attributes) || {};
          var same = Object.keys(attrs).every(function (k) { return cur[k] === attrs[k]; });
          if (same) return;
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs }),
          });
        });
    }).catch(function () { /* tracing must never break the page */ });
  }

  /* ── Orphaned personalisation-bundle cleanup ─────────────────────────────
     A personalisation is a BUNDLE of two lines sharing one id: a bottle line
     carrying an EngravingID / ColorPrintID, and a service line (hidden
     `_flexidesign` marker) carrying the SAME id. The two must live and die
     together — NEITHER half is valid alone:
       • a SERVICE with no matching bottle → billed, nothing to engrave;
       • a BOTTLE still carrying an id with no matching service → a broken
         bundle pointing at a design that was never paid for.
     So we remove BOTH halves of any broken bundle. A PLAIN bottle (no id) is
     valid and never touched; caps/boots carry no id so they're never touched
     either. We can't use a Cart Transform (it collides with 3rd-party discount
     apps), so we sweep on load and on every cart change. Mirrors
     bl_cart-bundle-role.liquid (bottle = shared id WITHOUT _flexidesign;
     service = WITH _flexidesign). */
  var _orphanBusy = false;
  function removeOrphanedBundleLines() {
    if (_orphanBusy) return;                 // also breaks the self-dispatch loop
    _orphanBusy = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var bid = function (it) { return (it.properties && (it.properties.EngravingID || it.properties.ColorPrintID)) || null; };
    var isService = function (it) { return !!(it.properties && it.properties._flexidesign); };
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        // null-proto so ids can't collide with __proto__/constructor/etc.
        var serviceIds = Object.create(null); // ids held by service lines
        var bottleIds  = Object.create(null); // ids held by non-service (bottle) lines
        items.forEach(function (it) {
          var b = bid(it); if (!b) return;
          if (isService(it)) serviceIds[b] = true; else bottleIds[b] = true;
        });
        var updates = {}, any = false;
        items.forEach(function (it) {
          var b = bid(it);
          if (!b) return;                    // plain bottle / cap / boot → always valid, never touched
          // Orphaned when the OTHER half of the bundle is missing:
          //   service line → needs a bottle sharing its id
          //   bottle line  → needs a service sharing its id
          var orphaned = isService(it) ? !bottleIds[b] : !serviceIds[b];
          if (orphaned) { updates[it.key] = 0; any = true; }
        });
        if (!any) return null;
        return fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          // Re-render cart UI + header badge now the broken bundle is gone. The
          // resulting cart:refresh re-enters this fn while _orphanBusy is still
          // true (reset below), so it no-ops — no loop.
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function () { /* cleanup must never break the page */ })
      .then(function () { _orphanBusy = false; });
  }
  function initOrphanBundleCleanup() {
    removeOrphanedBundleLines(); // sweep pre-existing broken bundles on load
    document.documentElement.addEventListener('cart:updated', function () { removeOrphanedBundleLines(); });
    document.documentElement.addEventListener('cart:refresh', function () { removeOrphanedBundleLines(); });
  }

  // Klaviyo form popups — Collection Drop (BL).
  // Markup: snippets/bl_klaviyo-popup.liquid — an openable-element (.modal,
  // moved to <body> via append-body) holding pasted Klaviyo embed code, with
  // an optional mobile variant. Opening/closing is the theme's toggle-button →
  // openable-element pair; this runtime only:
  //   1. sizes the popup to the Klaviyo form. Klaviyo renders asynchronously
  //      and puts the designed width inline as max-width on form.klaviyo-form;
  //      it is copied to --bl-kp-form-width (the image column of a split form
  //      has no intrinsic width, so max-content alone would under-size it).
  //      Re-measured on every (re)render and on resize (desktop/mobile switch);
  //   2. locks page scroll while a popup is open (openable-element does not;
  //      the theme's modal-content does, but also writes localStorage
  //      "theme:popup-appeared", which would suppress the Newsletter popup's
  //      "show only once");
  //   3. tracks a Klaviyo event on submit. The trigger button names it
  //      (data-klaviyo-event) and carries the payload (data-klaviyo-payload,
  //      JSON); the submit is matched by the form IDs found inside the popup;
  //   4. in the theme editor, opens a block's popup when the block is selected.
  function initKlaviyoPopups() {
    var POPUP = '.bl-klaviyo-popup';
    var TRIGGER = '[data-bl-klaviyo-popup][aria-controls]';
    var pending = null;

    function formIdsIn(popup) {
      var ids = [];
      popup.querySelectorAll('[class*="klaviyo-form-"]').forEach(function (el) {
        var m = /(?:^|\s)klaviyo-form-([A-Za-z0-9]+)/.exec(el.className || '');
        if (m && ids.indexOf(m[1]) === -1) ids.push(m[1]);
      });
      return ids;
    }

    // The Klaviyo <form> in the box shown at this screen size, or null.
    function formIn(popup) {
      var form = null;
      popup.querySelectorAll('.bl-klaviyo-popup__form').forEach(function (box) {
        if (form || getComputedStyle(box).display === 'none') return;
        form = box.querySelector('form.klaviyo-form') || box.querySelector('form');
      });
      return form;
    }

    // The form once Klaviyo (loaded async by its app embed) has actually drawn
    // it, or null. Klaviyo inserts the <form> before its content, so an empty
    // (zero-height) form still counts as not ready. A closed popup is only
    // visibility:hidden, so its layout — and the form's height — is measurable.
    function renderedForm(popup) {
      var form = formIn(popup);
      return form && form.offsetHeight > 0 ? form : null;
    }

    // Klaviyo removes or hides an embed form after its own close action ("No
    // thanks"). Swap each embed back to the bare <div class="klaviyo-form-ID">
    // so Klaviyo renders it afresh for the next open.
    function resetForms(popup) {
      popup.querySelectorAll('.bl-klaviyo-popup__form').forEach(function (box) {
        var ids = formIdsIn(box);
        if (!ids.length) return;
        box.innerHTML = ids.map(function (id) { return '<div class="klaviyo-form-' + id + '"></div>'; }).join('');
      });
    }

    // Resolves once the form has rendered, or after `timeout` ms regardless.
    // Polled: the form's height can change (fonts, images, Klaviyo's CSS)
    // without a DOM mutation to observe.
    function whenFormReady(popup, timeout) {
      return new Promise(function (resolve) {
        var started = Date.now();
        (function check() {
          if (renderedForm(popup) || Date.now() - started >= timeout) { resolve(); return; }
          setTimeout(check, 150);
        })();
      });
    }

    function fit(popup) {
      var form = formIn(popup);
      var maxWidth = form ? getComputedStyle(form).maxWidth : '';
      var next = /^\d+(\.\d+)?px$/.test(maxWidth) && parseFloat(maxWidth) > 0 ? maxWidth : '';
      if (popup.style.getPropertyValue('--bl-kp-form-width') === next) return; // no churn → no observer loop
      if (next) popup.style.setProperty('--bl-kp-form-width', next);
      else popup.style.removeProperty('--bl-kp-form-width');
    }

    function setup(popup) {
      if (popup.dataset.blKpReady) return;
      popup.dataset.blKpReady = '1';
      var scheduled = false;
      function schedule() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; fit(popup); });
      }
      fit(popup);
      if ('MutationObserver' in window) {
        new MutationObserver(schedule).observe(popup, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      }
      window.addEventListener('resize', schedule);
    }

    function scan(root) {
      if (!root || !root.querySelectorAll) return;
      if (root.matches && root.matches(POPUP)) setup(root);
      root.querySelectorAll(POPUP).forEach(setup);
    }

    scan(document);

    // Popups are moved to <body> on upgrade and re-created on editor re-renders.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    function isPopup(el) { return !!(el && el.matches && el.matches(POPUP)); }
    document.addEventListener('openable-element:open', function (e) {
      if (isPopup(e.target)) document.documentElement.classList.add('lock-all');
    });
    document.addEventListener('openable-element:close', function (e) {
      if (isPopup(e.target)) document.documentElement.classList.remove('lock-all');
    });

    function trackPending(btn, popup) {
      var payload = {};
      try { payload = JSON.parse(btn.getAttribute('data-klaviyo-payload') || '{}'); } catch (err) {}
      pending = {
        formIds: formIdsIn(popup),
        event: btn.getAttribute('data-klaviyo-event') || 'Popup Form Signup',
        payload: payload
      };
    }

    // Show the button's loader (theme toggle-button `loader` attribute +
    // aria-busy) and open the popup once the form has rendered, instead of
    // opening an empty popup.
    function openWhenReady(btn, popup) {
      // Queued clicks already show the loader; re-setting would restart its animation.
      if (btn.getAttribute('aria-busy') !== 'true') btn.setAttribute('aria-busy', 'true');
      whenFormReady(popup, 10000).then(function () {
        btn.setAttribute('aria-busy', 'false');
        btn.setAttribute('aria-expanded', 'true'); // toggle-button opens the popup
      });
    }

    // Capture phase: runs before the trigger's own toggle-button click handler,
    // so an open can be held back until the form has rendered.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest(TRIGGER) : null;
      if (!btn) return;
      var popup = document.getElementById(btn.getAttribute('aria-controls'));
      if (!popup) return;
      trackPending(btn, popup);
      if (btn.getAttribute('aria-expanded') === 'true' || renderedForm(popup)) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.getAttribute('aria-busy') === 'true') return;
      openWhenReady(btn, popup);
    }, true);

    // Clicks made before this script ran were held by the inline guard in
    // sections/bl_collection-drop.liquid (theme.js can already open the popup
    // while this deferred file is still loading). Take over from it now.
    window.blKlaviyoPopupReady = true;
    (window.blKlaviyoPopupQueue || []).forEach(function (btn) {
      var popup = document.getElementById(btn.getAttribute('aria-controls'));
      if (!popup) { btn.setAttribute('aria-busy', 'false'); return; }
      trackPending(btn, popup);
      openWhenReady(btn, popup);
    });
    window.blKlaviyoPopupQueue = [];

    // Klaviyo's own close action inside the form ("No thanks", its X) only
    // hides the form — close our popup + overlay with it.
    window.addEventListener('klaviyoForms', function (e) {
      var d = e && e.detail;
      if (!d || d.type !== 'close') return;
      document.querySelectorAll(POPUP + '[open]').forEach(function (popup) {
        if (formIdsIn(popup).indexOf(String(d.formId)) === -1) return;
        popup.open = false;
        setTimeout(function () { resetForms(popup); }, 300); // after the close transition
      });
    });

    window.addEventListener('klaviyoForms', function (e) {
      var d = e && e.detail;
      if (!d || !pending || d.type !== 'submit' || pending.formIds.indexOf(String(d.formId)) === -1) return;
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', pending.event, pending.payload]);
      pending = null;
    });

    if (window.Shopify && window.Shopify.designMode) {
      function togglePopupForBlock(e, open) {
        var target = e.target;
        if (!target || !target.querySelector) return;
        var trigger = target.matches && target.matches(TRIGGER) ? target : target.querySelector(TRIGGER);
        if (!trigger) return;
        var popup = document.getElementById(trigger.getAttribute('aria-controls'));
        if (popup) popup.open = open;
      }
      document.addEventListener('shopify:block:select', function (e) { togglePopupForBlock(e, true); });
      document.addEventListener('shopify:block:deselect', function (e) { togglePopupForBlock(e, false); });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mega-menu').forEach(initMegaMenuTabs);
    document.querySelectorAll('.bl_mobile-nav__link_collapsible').forEach(initMobileMegaMenuTabs);
    initHeaderRadius();
    initQuickFilter();
    initQuickNavInQuickBuy();
    initProductMediaStickyMobile();
    initTempRetentionBars();
    initQuickNavScrollbars();
    initProductMediaProgress();
    initCustomiseDeepLink();
    initBundleCartCount();
    initDeviceTraceAttributes();
    initOrphanBundleCleanup();
    initKlaviyoPopups();
  });
})();